import React from 'react';
import { fc } from '../../utils';

export function SpendingPredictionsCard({ insights, dayOfMonth, daysInMonth, vari, varBudget }) {
  if (!insights || insights.rows.length === 0 || dayOfMonth < 5) return null;

  const factor = daysInMonth / dayOfMonth;
  const totalPredicted = Math.round(vari * factor);

  const predictions = insights.rows
    .filter((r) => r.cur > 0)
    .map((r) => ({
      ...r,
      predicted: Math.round(r.cur * factor),
      overAvg: r.avg > 0 ? Math.round(r.cur * factor - r.avg) : null,
    }))
    .sort((a, b) => b.predicted - a.predicted)
    .slice(0, 5);

  if (predictions.length === 0) return null;

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 4 }}>
        <div className="st" style={{ marginBottom: 0 }}>🔮 End-of-Month Forecast</div>
        <span style={{ fontSize: 11, fontWeight: 700, color: totalPredicted > varBudget && varBudget > 0 ? 'var(--red)' : 'var(--grn)' }}>
          {fc(totalPredicted)} total
        </span>
      </div>
      <div style={{ fontSize: 10, color: 'var(--mut)', marginBottom: 10 }}>
        At current pace · {daysInMonth - dayOfMonth} days left
      </div>
      {predictions.map((r) => (
        <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 7 }}>
          <span style={{ fontSize: 14, width: 20, textAlign: 'center', flexShrink: 0 }}>{r.em}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 2 }}>
              <span style={{ fontSize: 11, fontWeight: 600 }}>{r.name}</span>
              <div style={{ display: 'flex', gap: 5, alignItems: 'baseline' }}>
                {r.overAvg !== null && r.overAvg !== 0 && (
                  <span style={{ fontSize: 9, fontWeight: 700, color: r.overAvg > 0 ? 'var(--red)' : 'var(--grn)' }}>
                    {r.overAvg > 0 ? '▲' : '▼'}{fc(Math.abs(r.overAvg))} vs avg
                  </span>
                )}
                <span style={{ fontSize: 12, fontWeight: 700, color: r.col }}>{fc(r.predicted)}</span>
              </div>
            </div>
            <div style={{ height: 4, background: 'var(--bdr)', borderRadius: 99, overflow: 'hidden' }}>
              <div style={{
                height: '100%', borderRadius: 99, background: r.col,
                width: (r.avg > 0 ? Math.min(120, Math.round((r.predicted / r.avg) * 100)) : 100) + '%',
              }} />
            </div>
          </div>
        </div>
      ))}
      {varBudget > 0 && (
        <div style={{
          marginTop: 8, padding: '7px 10px', borderRadius: 8, fontSize: 11,
          color: totalPredicted > varBudget ? 'var(--red)' : 'var(--grn)',
          background: totalPredicted > varBudget ? 'rgba(255,107,107,.08)' : 'rgba(107,203,119,.08)',
          border: `1px solid ${totalPredicted > varBudget ? 'rgba(255,107,107,.2)' : 'rgba(107,203,119,.2)'}`,
        }}>
          {totalPredicted > varBudget
            ? `⚠️ On track to exceed budget by ${fc(totalPredicted - varBudget)}`
            : `✓ On track to finish ${fc(varBudget - totalPredicted)} under budget`}
        </div>
      )}
    </div>
  );
}
